import {
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef, HostListener, Input,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {ModalRef} from '../../models/modal-ref.model';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss']
})
export class ModalContainerComponent implements OnInit {

  @Input() modalTitle = '';
  @Input() isClosable = true;
  @Input() size = '';
  @Input() modalStyle = '';
  @Input() showHeader = true;
  @Input() showFooter = true;
  showOverlayError = false;

  @ViewChild('modalContainer', {read: ViewContainerRef}) private modalContainer: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private modalRef: ModalRef) {
  }

  ngOnInit(): void {
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.code === 'Escape' && this.isClosable) {
      this.close();
    }
  }

  createModal<T>(component: Type<T>): ComponentRef<T> {
    this.modalContainer.clear();

    const factory: ComponentFactory<T> = this.componentFactoryResolver.resolveComponentFactory(component);

    return this.modalContainer.createComponent(factory, 0);
  }

  close() {
    this.modalRef.close();
  }

  onOverlayClick() {
    if (this.isClosable) {
      this.modalRef.close();
    } else {
      this.showOverlayError = true;
      setTimeout(() => {
        this.showOverlayError = false;
      }, 500);
    }
  }
}
